import { DOCUMENT } from '@angular/common';
import { computed, inject, Injectable } from '@angular/core';

import { StyleTheme, ThemeService } from '../../../core/services/store/common-store/theme.service';

/*
 * Service chuyển đổi theme
 * */
@Injectable({
  providedIn: 'root',
})
export class ThemeSkinService {
  private readonly doc = inject(DOCUMENT);
  private readonly themesService = inject(ThemeService);
  private $currentStyleTheme = computed(() => this.themesService.$themeStyle());

  removeUnusedTheme(theme: StyleTheme): void {
    const removedThemeStyle = this.doc.getElementById(theme as unknown as string);
    if (removedThemeStyle) {
      this.doc.documentElement.classList.remove(theme as unknown as string);
      this.doc.head.removeChild(removedThemeStyle);
    }
  }

  private loadCss(href: string, id: string): Promise<Event> {
    return new Promise((resolve, reject) => {
      const style = this.doc.createElement('link');
      style.rel = 'stylesheet';
      style.href = href;
      style.id = id;
      style.onload = resolve;
      style.onerror = reject;
      this.doc.head.append(style);
    });
  }

  public loadTheme(isFirstLoad = true): Promise<Event> {
    const theme = this.$currentStyleTheme();
    if (isFirstLoad) {
      this.doc.documentElement.classList.add(theme as unknown as string);
    }
    return new Promise<Event>((resolve, reject) => {
      this.loadCss(`${theme}.css`, theme as unknown as string).then(
        (e) => {
          if (!isFirstLoad) {
            this.doc.documentElement.classList.add(theme as unknown as string);
          }
          (['default', 'aliyun', 'compact', 'dark'] as string[])
            .filter((item) => item !== (this.$currentStyleTheme() as unknown as string))
            .forEach((item) => {
              setTimeout(() => {
                this.removeUnusedTheme(item as unknown as any);
              }, 1);
            });

          resolve(e);
        },
        (e) => reject(e)
      );
    });
  }

  public toggleTheme(): Promise<Event> {
    return this.loadTheme(false);
  }
}
